export default __webpack_public_path__ + "static/media/photo--lg--pam3.0c0e9528.jpg";